module.exports = __webpack_public_path__ + "img/Loading.2b737b6e.gif";